import React from "react";
import { Dashboard } from "@ui/Illustration/react";
import { styled } from "@linaria/react";
import t from "../../../../i18n";
import BlankStateV2 from "@ui/BlankStateV2";

const EmptyChartBlankState = styled(BlankStateV2)`
  padding-top: 0;
`;

function EmptyReporting({ className }: { className?: string }) {
  return (
    <EmptyChartBlankState
      className={className}
      title={t("flags_legend.noDataIntervals")}
      picto={<Dashboard size="l" />}
    />
  );
}

export default React.memo(EmptyReporting);
